<template>
  <footer class="relative bg-[#141523] py-10 overflow-hidden ">
    <!-- Background Image -->
    <img src="../assets/FooterBG1.png" alt="Footer Background" class="absolute inset-0 w-full h-full object-cover z-0">

    <div class="container mx-auto px-4 relative z-10 flex justify-between items-center mb-8">
      <!-- Logo -->
      <div class="text-left">
        <img src="../assets/Frame 16 (1).png" alt="Logo" class="md:h-14 w-auto h-10">
      </div>
      <!-- Contact Us Button -->
      <div>
        <a
          href="mailto:contact@cardwarewallet.com"
          class="bg-[#FFF9F7] text-[#141523] font-archivoregular px-4 py-2 rounded-full shadow-md border-2 border-[#141523] hover:bg-[#FF6000] hover:text-white transition duration-200"
        >
          Contact Us
        </a>
      </div>
    </div>

    <div class="container mx-auto px-6 relative z-10 pl-4 pr-6">
      <!-- Links -->
      <div class="flex justify-center mb-16 md:space-x-32 space-x-10">
        <!-- First Column -->
        <div class="space-y-2 text-center font-archivolight">
          <a href="/" class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]">Home</a>
          <a href="/enterprise" class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]">Services</a>
          <a href="mailto:contact@cardwarewallet.com" class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]">Contact</a>
          <a
            href="https://docs.cardwarewallet.com/cardware-wallet-documentation/compliance-pack/privacy-policy"
            target="_blank"
            class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]"
          >
            Privacy Policy
          </a>
        </div>
        <!-- Second Column -->
        <div class="space-y-2 text-center font-archivolight">
          <a
            href="https://docs.cardwarewallet.com/cardware-wallet-documentation/compliance-pack/terms-and-conditions"
            target="_blank"
            class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]"
          >
            Terms & Conditions
          </a>
          <a href="mailto:contact@cardwarewallet.com" class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]">
            Support
          </a>
          <a
            href="https://docs.cardwarewallet.com/cardware-wallet-documentation/compliance-pack"
            target="_blank"
            class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]"
          >
            Compliance
          </a>
          <a
            href="https://docs.cardwarewallet.com/cardware-wallet-documentation/compliance-pack/warranty"
            target="_blank"
            class="block text-sm text-[#FFF9F7] hover:text-[#FF6000]"
          >
            Warranty
          </a>
        </div>
        <!-- Third Column (Social Links) -->
        <div class="space-y-2 text-center font-archivolight">
          <a
            href="https://x.com/CardwareWallet"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/Twitter.png" alt="Twitter Icon" class="w-4 h-4" />
            <span>Twitter</span>
          </a>
          <a
            href="https://t.me/cardwarewallet"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/Telegram.png" alt="Telegram Icon" class="w-4 h-4" />
            <span>Telegram</span>
          </a>
          <a
            href="https://discord.com/invite/dgDXR85CXB"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/Discord.png" alt="Discord Icon" class="w-4 h-4" />
            <span>Discord</span>
          </a>
          <a
            href="https://www.linkedin.com/company/cardware-wallet/"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/LinkedIn.png" alt="LinkedIn Icon" class="w-4 h-4" />
            <span>LinkedIn</span>
          </a>
          <a
            href="https://github.com/cardware-wallet"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/Github_Icon.png" alt="LinkedIn Icon" class="w-4 h-4" />
            <span>Github</span>
          </a>
          <!-- <a
            href="https://www.reddit.com/r/CardwareWallet/"
            class="block text-[#FFF9F7] hover:text-[#FF6000] text-sm hover:underline flex justify-center items-center space-x-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/RedditIcon.png" alt="Reddit Icon" class="w-4 h-4" />
            <span>Reddit</span>
          </a> -->
        </div>
      </div>
      <!-- Disclaimer -->
      <div class="text-center text-xs text-[#FFF9F7] font-archivolight">
        <p>&copy; 2025 Cardware Wallet (Pty) Ltd. All rights reserved.</p>
        <p>Central Square, Pinelands, Cape Town, South Africa.</p>
        <p>
          For more information on our Terms & Conditions, please see our
          <a
            href="https://docs.cardwarewallet.com/cardware-wallet-documentation/compliance-pack/terms-and-conditions"
            class="text-white hover:text-[#FF6000] hover:underline"
            target="_blank"
            alt="Compliance Pack"
          >
            Compliance Pack
          </a>.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter',
};
</script>

<style scoped>

</style>
